import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useCursorPagination = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const cursors = useMemo<{ createdAt: string; id: string }[]>(() => {
    try {
      const raw = searchParams.get('cursors');
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }, [searchParams]);

  const currentCursor = cursors[cursors.length - 1];
  const currentPage = cursors.length + 1;
  const hasPrevPage = cursors.length > 0;

  const pushCursor = (cursor: { createdAt: string; id: string }) => {
    setSearchParams({ cursors: JSON.stringify([...cursors, cursor]) });
  };

  const goToPrevPage = () => {
    const prev = cursors.slice(0, -1);
    setSearchParams(prev.length === 0 ? {} : { cursors: JSON.stringify(prev) });
  };

  const resetCursors = () => setSearchParams({});

  return { currentCursor, currentPage, hasPrevPage, pushCursor, goToPrevPage, resetCursors };
};
